import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addDepartments = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.create_department',
    body
  );
  return data;
});
export const updateDepartments = catchAsync(async (body) => {
  const { data } = await axiosInstance.put(
    '/api/method/technoerp.services.update_department',
    body
  );
  return data;
});

export const addPractitionerSchedule = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Practitioner Schedule',
    body
  );
  return data;
});
export const updatePractitionerSchedule = catchAsync(async ({ body, id }) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Practitioner Schedule/${id}`,
    body
  );
  return data;
});
export const deletePractitionerSchedule = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Practitioner Schedule/${id}`
  );
  return data;
});

export const getPractitionerScheduleInfo = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Practitioner Schedule/${id}`
  );
  return data;
});
export const getDepartmentInfo = catchAsync(async (department) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_department?department=${department}`
  );
  return data;
});

export const getDepartments = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_departments'
  );
  return data;
});
export const getPatientCareTypes = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_patient_care_types'
  );
  return data;
});
export const deleteDepartments = catchAsync(async (data) => {
  const { deleteDep } = await axiosInstance.delete(
    `/api/method/technoerp.services.delete_record?record=${data.record}&document=Medical Department`
  );
  return deleteDep;
});
